/* Ott-common */
import { normalize } from '@dtvgo/typed-normalizr';
import { AuthType } from '@dtvgo/axios-interceptor-auth';

/* Utils */
import { ShowEntity, SeasonEntity, PROVIDER } from '../../../utils';

/**
 * @param {import('axios').AxiosInstance} backendAxiosInstance
 */
export default function shows(backendAxiosInstance) {
  /**
   * @typedef OptionalLanguageParams
   * @type {object}
   * @property {'es'|'en'|'pt'|'*'} [language]
   */

  /**
   * @param {string} showId
   */
  async function getShowById(showId) {
    const response = await backendAxiosInstance.get(`/blim/content/v1/shows/${showId}`, {
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize({
      sourceProvider: PROVIDER.BLIM,
      seasonCount: response.data.seasonList.length,
      ...response.data,
    }, ShowEntity);

    return response;
  }

  /**
   * @param {string} showId
   * @param {string} seasonNumber
   */
  async function getSeasonById(showId, seasonNumber) {
    const response = await backendAxiosInstance.get(`/blim/content/v1/shows/${showId}/seasons/${seasonNumber}`, {
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize({
      id: `${showId}_${seasonNumber}`,
      seasonNumber,
      sourceProvider: PROVIDER.BLIM,
      episodesIds: response.data.episodes,
      ...response.data,
    }, SeasonEntity);

    return response;
  }

  return {
    getShowById,
    getSeasonById,
  };
}
